<template>
    <div class="container-fluid">
        <div class="container is-fluid">

            <div v-if="isAdmin" class="columns">

                <div class="column has-text-centered">
                    <h1 class="title">Transaction</h1>
                </div>
            </div>

            <div class="columns">
                <div class="column">

                    <div class="field-row">
                        <div class="field transaction-field">
                            <p class="control search-field is-expanded has-icons-left is-fullwidth">
                                <input class="input" type="text" v-model="search" v-on:keyup="searchFormChange"
                                       placeholder="Search Transactions">
                                <span class="icon is-small is-left">
                      <i class="fas fa-search"></i>
                    </span>
                            </p>
                        </div>
                        <div class="field transaction-date">
                            <p class="control is-expanded has-icons-left is-fullwidth">
                                <datetime
                                        input-class="input"
                                        v-model="transaction_from"
                                        @change="filter"
                                        :format="{ year: 'numeric', month: 'numeric', day: 'numeric'}"
                                        type="date"
                                        value-zone="local"
                                        zone="local"
                                        placeholder="Select date from"
                                ></datetime>
                                <span class="icon is-small is-left">
                      <i class="fas fa-calendar-alt"></i>
                    </span>
                            </p>
                        </div>
                        <div class="field transaction-date">
                            <p class="control is-expanded has-icons-left is-fullwidth">
                                <datetime
                                        input-class="input"
                                        v-model="transaction_to"
                                        @change="filter"
                                        :format="{ year: 'numeric', month: 'numeric', day: 'numeric'}"
                                        type="date"
                                        value-zone="local"
                                        zone="local"
                                        placeholder="Select date to"
                                ></datetime>
                                <span class="icon is-small is-left">
                      <i class="fas fa-calendar-alt"></i>
                    </span>
                            </p>
                        </div>
                    </div>

                </div>
            </div>

            <app-loader :loading="false" :color="options.color" :size="options.size"></app-loader>
            <div class="columns" v-if="transactionTotals">
                <div class="theme-table-container table-container center-column w-100">
                    <table class="theme-table table is-responsive-table is-fullwidth is-scrollable is-striped">
                        <tr>
                            <th>Amount received</th>
                            <td>¥{{ transactionTotals.moneyIn | formatNumber }}</td>
                            <th>Amount used for payments</th>
                            <td>¥{{ transactionTotals.payment | formatNumber }}</td>
                            <th>Amount in Excess</th>
                            <td>¥{{ transactionTotals.moneyIn - transactionTotals.subTotal | formatNumber }}</td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="columns center" v-if="!getLoaderStatus">
                <div class="theme-table-container table-container center-column w-100">
                    <table class="theme-table table is-responsive-table is-fullwidth is-scrollable is-striped">
                        <thead>
                        <tr>
                            <th><span @click="setOrder('id')" class="link">ID</span></th>
                            <th><span @click="setOrder('transaction_date')" class="link">Date</span></th>
                            <th><span @click="setOrder('type')" class="link">Type</span></th>
                            <th><span @click="setOrder('amount')" class="link">Amount</span></th>
                        </tr>
                        </thead>
                        <transaction-user-table-row></transaction-user-table-row>
                    </table>
                </div>
            </div>
            <div class="columns" v-if="hasTransactions">
                <div class="column has-text-centered">
                    <nav class="pagination is-centered" role="navigation" aria-label="pagination">
                        <ul class="pagination-list">
                            <li><a class="pagination-link" v-if="getCurrentPage > 2" @click="changePage(getFirstPage)">{{ getFirstPage }}</a></li>
                            <li><span class="pagination-ellipsis" v-if="getCurrentPage > 2">&hellip;</span></li>
                            <li><a class="pagination-link" v-if="getCurrentPage > 1" @click="changePage(getCurrentPage - 1)">{{ getCurrentPage - 1 }}</a></li>
                            <li><a class="pagination-link is-current" @click="changePage(getCurrentPage)">{{ getCurrentPage }}</a></li>
                            <li><a class="pagination-link" v-if="getCurrentPage < getLastPage"  @click="changePage(getCurrentPage + 1)">{{ getCurrentPage + 1 }}</a></li>
                            <li><span class="pagination-ellipsis" v-if="getCurrentPage + 1 < getLastPage">&hellip;</span></li>
                            <li><a class="pagination-link" @click="changePage(getLastPage)" v-if="getCurrentPage + 1 < getLastPage">{{ getLastPage }}</a></li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import appLoader from 'vue-spinner/src/ClipLoader'
    import {Datetime} from 'vue-datetime'
    import 'vue-datetime/dist/vue-datetime.css'
    import {ModelSelect} from 'vue-search-select'
    import TransactionUserTableRow from "./TransactionUserTableRow";

    export default {
        props: ['user'],
        components: {
            TransactionUserTableRow,
            appLoader,
            Datetime,
            ModelSelect
        },
        data() {
            return {
                options: [],
                addTransactionModal: false,
                search: '',
                client: this.$route.params.id,
                dateFrom: '',
                dateTo: '',
                order: 1,
                clientId: this.$route.params.id
            }
        },
        computed: {
            hasTransactions() {
                return this.$store.getters.getAllTransactions.length > 0 ? true : false;
            },
            getCurrentPage() {
                return parseInt(this.$store.getters.getTransactionCurrentPage)
            },
            getLoaderStatus() {
                return this.$store.getters.getLoaderStatus
            },
            transaction_from: {
                get() {
                    return this.dateFrom;
                },
                set(value) {
                    this.dateFrom = value;
                    this.filter();
                }
            },
            transaction_to: {
                get() {
                    return this.dateTo;
                },
                set(value) {
                    this.dateTo = value;
                    this.filter();
                }
            },
            transactionTotals() {
                return this.$store.getters.getClientTransactionTotals;
            },
            getFirstPage() {
                return this.$store.getters.getTransactionFirstPage
            },
            getLastPage() {
                return this.$store.getters.getTransactionLastPage
            },
            isAdmin() {
                if (this.$store.getters.getUserRole === 'Admin') {
                    return true
                }
            },
            currentRouteName(){
                return this.$route.name;
            }
        },
        methods: {
            setOrder(orderBy){
                this.order = this.order == '1' ? 0 : 1;
                this.$store.commit('setOrderByTransactions', {orderBy: orderBy, order: this.order})
                this.$store.dispatch('getTransactionsAction');
            },
            filter() {
                this.$store.commit('setFilterTransactions', {client: this.client, search: this.search, dateFrom: this.dateFrom, dateTo: this.dateTo})
                this.$store.dispatch('getTransactionsAction');
            },
            searchFormChange() {
                this.filter();
            },
            addTransaction() {
                this.addTransactionModal = true;
            },
            changePage(page) {
                this.$router.push({path: '/banking', query: {page: page}})
            }
        },
        created() {
            this.$store.commit('setClientTransactionTotals', '')
            this.$store.dispatch('getUserTransactionTotals', this.$route.params.id)
        },
        watch: {
            '$route'(to, from) {
                this.$store.commit('setTransactionCurrentPage', to.query.page)
                this.$store.dispatch('getTransactionsAction')
            }
        }
    }
</script>
<style scoped>
    .container {
        margin-top: 25px;
    }

    .field-row {
        display: flex;
    }

    .field-row .field {
        margin-right: 10px;
    }

    .field.transaction-field, .field.client-field {
        flex: 1 1 33%;
    }

    .field.transaction-field {
        flex: 1 1 33%;
    }

    .ui.selection.dropdown {
        min-height: unset;
        padding-top: 9px;
    }
    span.link {
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/UserBanking/TransactionsUserTable.vue